import BellSvg from '@/icons/svg/bell.svg?react'
import CameraSvg from '@/icons/svg/camera.svg?react'
import CardMultipleSvg from '@/icons/svg/card-multiple.svg?react'
import CardSingleSvg from '@/icons/svg/card-single.svg?react'
import CartSvg from '@/icons/svg/cart.svg?react'
import CheckmarkSvg from '@/icons/svg/checkmark.svg?react'
import ChevronDownSvg from '@/icons/svg/chevron-down.svg?react'
import ChevronLeftSvg from '@/icons/svg/chevron-left.svg?react'
import ChevronRightSvg from '@/icons/svg/chevron-right.svg?react'
import ClipboardSvg from '@/icons/svg/clipboard.svg?react'
import CloseSvg from '@/icons/svg/close.svg?react'
import DollarSvg from '@/icons/svg/dollar.svg?react'
import EditSvg from '@/icons/svg/edit.svg?react'
import ExternalLinkSvg from '@/icons/svg/external-link.svg?react'
import EyeClosedSvg from '@/icons/svg/eye-closed.svg?react'
import EyeOpenSvg from '@/icons/svg/eye-open.svg?react'
import FeedbackSvg from '@/icons/svg/feedback.svg?react'
import FilterSvg from '@/icons/svg/filter.svg?react'
import HeartSvg from '@/icons/svg/heart.svg?react'
import HomeSvg from '@/icons/svg/home.svg?react'
import LogOutSvg from '@/icons/svg/log-out.svg?react'
import MinusSvg from '@/icons/svg/minus.svg?react'
import MoonSvg from '@/icons/svg/moon.svg?react'
import MoreSvg from '@/icons/svg/more.svg?react'
import PlusSvg from '@/icons/svg/plus.svg?react'
import SearchSvg from '@/icons/svg/search.svg?react'
import ShareSvg from '@/icons/svg/share.svg?react'
import SortAscSvg from '@/icons/svg/sort-asc.svg?react'
import SortDescSvg from '@/icons/svg/sort-desc.svg?react'
import SunSvg from '@/icons/svg/sun.svg?react'
import TrashSvg from '@/icons/svg/trash.svg?react'
import ViewCompactSvg from '@/icons/svg/view-compact.svg?react'
import ViewGridSvg from '@/icons/svg/view-grid.svg?react'
import ViewListSvg from '@/icons/svg/view-list.svg?react'
import WarningSvg from '@/icons/svg/warning.svg?react'

interface IconProps {
  className?: string
}

export function SearchIcon({ className }: IconProps) {
  return <SearchSvg className={className} />
}

export function EyeOpenIcon({ className }: IconProps) {
  return <EyeOpenSvg className={className} />
}

export function EyeClosedIcon({ className }: IconProps) {
  return <EyeClosedSvg className={className} />
}

export function PlusIcon({ className }: IconProps) {
  return <PlusSvg className={className} />
}

export function MinusIcon({ className }: IconProps) {
  return <MinusSvg className={className} />
}

export function CartIcon({ className }: IconProps) {
  return <CartSvg className={className} />
}

export function DollarIcon({ className }: IconProps) {
  return <DollarSvg className={className} />
}

export function CameraIcon({ className }: IconProps) {
  return <CameraSvg className={className} />
}

export function CloseIcon({ className }: IconProps) {
  return <CloseSvg className={className} />
}

export function ClipboardIcon({ className }: IconProps) {
  return <ClipboardSvg className={className} />
}

export function CheckmarkIcon({ className }: IconProps) {
  return <CheckmarkSvg className={className} />
}

export function ExternalLinkIcon({ className }: IconProps) {
  return <ExternalLinkSvg className={className} />
}

export function ChevronDownIcon({ className }: IconProps) {
  return <ChevronDownSvg className={className} />
}

export function ChevronRightIcon({ className }: IconProps) {
  return <ChevronRightSvg className={className} />
}

export function ChevronLeftIcon({ className }: IconProps) {
  return <ChevronLeftSvg className={className} />
}

export function TrashIcon({ className }: IconProps) {
  return <TrashSvg className={className} />
}

export function FilterIcon({ className }: IconProps) {
  return <FilterSvg className={className} />
}

export function EditIcon({ className }: IconProps) {
  return <EditSvg className={className} />
}

export function WarningIcon({ className }: IconProps) {
  return <WarningSvg className={className} />
}

export function BellIcon({ className }: IconProps) {
  return <BellSvg className={className} />
}

export function ShareIcon({ className }: IconProps) {
  return <ShareSvg className={className} />
}

export function HeartIcon({ className }: IconProps) {
  return <HeartSvg className={className} />
}

export function CardSingleIcon({ className }: IconProps) {
  return <CardSingleSvg className={className} />
}

export function CardMultipleIcon({ className }: IconProps) {
  return <CardMultipleSvg className={className} />
}

export function SunIcon({ className }: IconProps) {
  return <SunSvg className={className} />
}

export function MoonIcon({ className }: IconProps) {
  return <MoonSvg className={className} />
}

export function SortAscIcon({ className }: IconProps) {
  return <SortAscSvg className={className} />
}

export function SortDescIcon({ className }: IconProps) {
  return <SortDescSvg className={className} />
}

export function ViewGridIcon({ className }: IconProps) {
  return <ViewGridSvg className={className} />
}

export function ViewCompactIcon({ className }: IconProps) {
  return <ViewCompactSvg className={className} />
}

export function ViewListIcon({ className }: IconProps) {
  return <ViewListSvg className={className} />
}

export function HomeIcon({ className }: IconProps) {
  return <HomeSvg className={className} />
}

export function MoreIcon({ className }: IconProps) {
  return <MoreSvg className={className} />
}

export function FeedbackIcon({ className }: IconProps) {
  return <FeedbackSvg className={className} />
}

export function LogOutIcon({ className }: IconProps) {
  return <LogOutSvg className={className} />
}
